import ScannerWidget from "../components/ScannerWidget";
import { ShieldCheck } from "lucide-react";

export default function FreeScan() {
  return (
    <div className="bg-gradient-to-b from-slate-950 via-indigo-950 to-slate-950 text-white min-h-[80vh]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
        <p className="font-mono text-xs uppercase tracking-widest text-indigo-300 mb-5">Free AI Revenue Readiness Scan</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight leading-tight">Enter your website. See what AI sees.</h1>
        <p className="mt-5 text-slate-300 max-w-xl mx-auto">We'll analyze your live site for AI discoverability, machine readability, transaction and payment readiness — then give you a score out of 100.</p>
        <div className="mt-10 flex flex-col items-center">
          <ScannerWidget variant="hero" />
        </div>
        <p className="mt-10 text-sm text-slate-400 flex items-center justify-center gap-2"><ShieldCheck className="h-4 w-4 text-emerald-400" /> No phone. No revenue questions. No payment to see your score.</p>
      </div>
    </div>
  );
}
